// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__qy5M5","options":"AnswerScale_options__2nrQc","selected":"AnswerScale_selected__1i6jW"};